import { CompleteTaskResponse } from "./types";

interface ErrorWithResponse {
  response?: {
    data?: {
      message?: string;
    };
  };
  message?: string;
}

export const getCompleteTaskSuccessMessage = (
  response?: CompleteTaskResponse,
) => response?.message || "Task completed successfully.";

export const getCompleteTaskErrorMessage = (error: unknown) => {
  const completionError = error as ErrorWithResponse;
  const message =
    completionError.response?.data?.message ||
    completionError.message ||
    "Unknown error";

  return `Failed to complete task. Reason: ${message}`;
};
